export const financialData = {
  success: true,
  data: {
    claim_id: "TEST1234",
    financial_summary: {
      thru_date: "2026-01-28", // ?
      orig_claim: 59.18, // [MASTER.ORIG_CLAIM]
      charges: 1.00,  // ?
      interest_rate: 5.5, // ?
      total_interest: 0.50, // ?
      total_credits: 1.25,
      total_due: 58.92,
      calculated_interest: 0.50
    },
    
    breakdown: {
      placed_amount: 59.17,
      additional_charges: 1.00,
      credit_adjustments: -1.25,
      interest_accrued: 0.50,
      net_total: 58.92
    },
    
    calculation_notes: {
      thru_date_description: "The 'Thru Date' for interest calculation",
      charges_formula: "Total Due - Credits - Interest Accrued - Original Claim Amount",
      interest_note: "Interest rate currently applied to the claim"
    }
  },
  metadata: {
    calculated_at: "2024-01-30T10:00:00Z",
    currency: "USD"
  }
};